<template>
    <div class="cl-input" :class="{search, warning: tip}">
        <slot name="prepend"></slot>
        <textarea class="text-area"
                v-bind="$attrs"
                :value="value"
                v-on="inputListeners" v-if="type == 'textarea'"></textarea>
        <input class="input"
                :type="type"
                v-bind="$attrs"
                :value="value"
                v-on="inputListeners" @keyup.enter="handleSearch" v-else>
        <div class="icon-search search" v-if="search" @click="handleSearch"></div>
        <div class="tip" v-if="tip">{{tip}}</div>
    </div>
</template>

<script>
    import mixins from "./mixins";
    export default {
        name: "clInput",
        mixins: [mixins],
        props: {
            type: String,
            value: [String, Number],
            search: Boolean,
            rules: Array
        },
        data() {
            return {
                tip: null
            }
        },
        computed: {
            inputListeners: function () {
                let vm = this;
                return Object.assign({},
                    // 我们从父级添加所有的监听器
                    this.$listeners,
                    // 然后我们添加自定义监听器，
                    // 或覆写一些监听器的行为
                    {
                        // 这里确保组件配合 `v-model` 的工作
                        input: function (event) {
                            let value = event.target.value;
                            vm.$emit('input', value);
                        },
                        blur: function (event) {
                            vm.$emit('blur', event);
                            vm.notifyCheck();
                        }
                    }
                )
            }
        },
        methods: {
            handleSearch() {
                if(this.search) {
                    this.$emit('search');
                }
            }
        }
    }
</script>

<style lang="less">
    .cl-input {
        flex: 1;
        position: relative;
        border: var(--border);
        border-radius: 8px;
        &.warning {
            margin-bottom: 36px;
            .input {
                border-color: var(--error-color);
            }
        }
        &.search {
            .input {
                padding-right: 60px;
            }
        }
        .text-area,
        .input {
            padding: 0 20px;
            border-radius: 8px;
            font-size: 24px;
            line-height: 56px;
        }
        .input {
            height: 56px;
            &[type='number']::-webkit-outer-spin-button,
            &[type='number']::-webkit-inner-spin-button {
                -webkit-appearance: none;
            }
        }
        .text-area {
            padding: 20px;
            height: 200px;
            line-height: 1.5;
            resize: none;
        }
        .search {
            position: absolute;
            top: 1px;
            right: 1px;
            bottom: 0;
            width: 56px;
            height: 56px;
            cursor: pointer;
            font-size: 32px;
            text-align: center;
            line-height: 56px;
            color: var(--tip-font-color);
            &:hover {
                background-color: var(--back-grey-color);
            }
        }
        .tip {
            position: absolute;
            left: 0;
            bottom: -36px;
            line-height: 1;
        }
    }
</style>
